import styled, { css } from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  ${({ theme }) => css`
    margin-left: auto;
    margin-right: auto;
    margin-top: 14rem;
    width: 45%;
    height: 460px;
    border: 0;
    background-color: ${theme.colors.gstWhite};

    @media only screen and (max-width: 767px) {
      width: 90%;
      height: 430px;
    }
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      width: 70%;
    }
  `}
`;

export const CardHeader = styled.div`
  ${({ theme, color, company }) => css`
    text-align: center;
    font-weight: 600;
    margin-bottom: 0;
    background-color: ${color ? color : theme.colors.gstBlue};
    color: ${theme.colors.gstWhite};
    padding: 0.9rem;
    font-size: 16px;
    font-family: "Raleway", sans-serif;
  `}
`;

export const CardBody = styled.div`
  /* ... */
`;

export const Form = styled.form`
  ${({ theme }) => css`
    padding: 0 15%;
    padding-top: 6%;
    background: ${theme.colors.gstWhite};

    @media only screen and (max-width: 767px) {
      padding: 5%;
    }
  `}
`;

export const RegisterWrap = styled.div`
  ${({ theme }) => css`
    position: relative;
    margin: auto;
    width: 80%;
    display: flex;
    flex-flow: row;
    @media only screen and (max-width: 767px) {
      display: flex;
      flex-flow: column;
      padding: 0 5%;
      margin: 0;
      bottom: 10px;
    }
    a {
      font-size: 12px;
      color: ${theme.colors.lightGrey};
      text-transform: uppercase;
      cursor: pointer;
      font-weight: bold;
      margin-right: 30px;
      text-decoration: none;
      font-family: "Raleway", sans-serif;
      &:hover {
        color: ${theme.colors.hoverBlue};
        text-decoration: underline;
      }
    }
  `}
`;

export const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 20px;
  padding-bottom: 20px;
  width: 100%;
`;

export const EyeContainer = styled.div`
  position: relative;
  top: -55px;
  float: right;
  right: 19px;
  font-size: 20px;
  &:hover {
    color: #66d7d1;
  }
`;

export const Eye = styled.div``;

export const Response = styled.div`
  position: relative;
  top: 15%;
  left: 50%;
  transform: translateX(-50%);
  background: ${(props) => (props.type === "success" ? "#e0ffe0" : "#ffe0e0")};
  color: ${(props) => (props.type === "success" ? "#007500" : "#c01616")};
  width: 30%;
  padding: 1rem 2rem;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 1001; /* Above the overlay */
  font-size: 1.3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap; /* Prevent wrapping */

  @media only screen and (max-width: 767px) {
    width: 90%;
    font-size: 1rem;
    padding: 1rem;
    top: 30%;
    flex-direction: row; /* Ensure elements stay in a row */
    align-items: center;
  }
  @media (min-width: 768px) and (max-width: 1440px) {
    width: 60%;
    font-size: 1rem;
    padding: 1rem;
    top: 30%;
    flex-direction: row; /* Ensure elements stay in a row */
    align-items: center;
  }
`;

export const AlertIcon = styled.span`
  width: 30px;
  height: 30px;
  background-color: white;
  color: ${(props) => (props.state === "error" ? "#d10000" : "#007500")};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 18px;
  font-weight: bold;
  font-family: Arial, sans-serif;
  margin-right: 1rem;

  @media only screen and (max-width: 767px) {
    width: 25px;
    height: 25px;
    font-size: 16px;
    margin-right: 0.5rem;
  }
`;

export const ResponseMessage = styled.span`
  flex-grow: 1;
  font-size: 1.2rem;
  color: inherit;
  font-weight: bold;
  white-space: nowrap; /* Prevent text wrapping */
  overflow: hidden; /* Hide overflowing text */
  text-overflow: ellipsis; /* Add ellipsis for overflowing text */

  @media only screen and (max-width: 767px) {
    font-size: 1rem;
    margin-bottom: 0;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  color: #d10000;
  font-weight: bold;
  font-size: 1.4rem;
  border: none;
  cursor: pointer;
  margin-left: 1rem;

  @media only screen and (max-width: 767px) {
    font-size: 1.2rem;
    margin-left: 0;
  }
`;

export const ResponseContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  @media only screen and (max-width: 767px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  z-index: 1000; /* Below the response */
`;
